import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import classnames from 'classnames';

import InformationIcon from 'Components/icons/information-icon/InformationIcon.jsx';
import ErrorIcon from 'Components/icons/error-icon/ErrorIcon.jsx';

import './InformationBubble.scss';

const InformationBubble = ({ error, info, icon, id, tooltipTitle, tooltipContent, children, place, isSharedReportTooltTip, position, probability, reportName }) => {
  const infoIcon = <InformationIcon info={info} />;
  const probabilityIcon = <InformationIcon info={probability} />;
  const errorIcon = <ErrorIcon error={error} />;
  const langCode = JSON.parse(sessionStorage.getItem('state')).auth.user.languageAbbr;

  const tooltipClasses = classnames('tooltip', {
    error,
    info,
    position,
    probability,
  });

  const informationWrappeClass = classnames('information-bubble__wrapper', { report_card_tooltip: isSharedReportTooltTip });

  const tooltipIcon = (icon)
    ? <span className="tooltip__icon">{icon}</span>
    : null;

  return (
    <div className={informationWrappeClass} style={reportName && (reportName == "Business Rules_filterPane" || reportName == "Other Existing Rules") ? { marginLeft: "-12px", marginTop: "-2px" } : reportName == "MRE" ? { position: "absolute", marginLeft: langCode == 'FC' ? "-5px" : langCode == 'ES' ? "-8px" : "1px", marginTop: "2px" } : reportName == "create_action" ? {} : {}}>
      <span data-tooltip-id={id}>
        {info && infoIcon}
        {error && errorIcon}
        {probability && probabilityIcon}
        {children}
      </span>
      {
        place ? <ReactTooltip place={place} id={String(id)} className={tooltipClasses}>
          {tooltipIcon}
          {' '}{tooltipTitle && <h1 className="headline">{tooltipTitle}</h1>}
          <span>{tooltipContent}</span>
        </ReactTooltip> : reportName && (reportName == "Business Rules_filterPane" || reportName == "Other Existing Rules" || reportName == "MRE" || reportName == 'create_action') ? <ReactTooltip id={String(id)} className={tooltipClasses}>
          {tooltipIcon}
          {tooltipTitle && <h1 className="headline">{tooltipTitle}</h1>}
          <span>{tooltipContent}</span>
        </ReactTooltip> : <ReactTooltip id={String(id)} className={tooltipClasses}>
          {tooltipIcon}
          {' '}{tooltipTitle && <h1 className="headline">{tooltipTitle}</h1>}
          <span>{tooltipContent}</span>
        </ReactTooltip>
      }

    </div>
  );
};

export default InformationBubble;

InformationBubble.propTypes = {
  error: PropTypes.bool,
  icon: PropTypes.element,
  info: PropTypes.bool,
  probability: PropTypes.bool,
  tooltipTitle: PropTypes.string,
  tooltipContent: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  place: PropTypes.string,
  isSharedReportTooltTip: PropTypes.bool,
  position: PropTypes.bool,
};

InformationBubble.defaultProps = {
  error: false,
  icon: null,
  info: false,
  probability: false,
  tooltipTitle: '',
  tooltipContent: '',
  id: 'icon',
  children: React.createElement('div'),
  isSharedReportTooltTip: false,
  position: false,
};
